import CartEntity from "@modules/cart/entities/CartEntity";

import CartManagerItemsUpdaterInterface from "./CartManagerItemsUpdaterInterface";

class CartManagerItemsUpdatersContext {
    private updaters: CartManagerItemsUpdaterInterface[] = [];
    addItemsUpdater(counterUpdater: CartManagerItemsUpdaterInterface) {
        this.updaters.push(counterUpdater);
    }
    async updateItems(cart: CartEntity): Promise<boolean> {
        for (const updater of this.updaters) {
            const result = await updater.updateItems(cart);
            if (result) return result;
        }
        return false;
    }
}

export default CartManagerItemsUpdatersContext;
